module.exports = __webpack_public_path__ + "static/media/sources.8a066aa0.png";